define('models/pages/claims/index',[
    'underscore',
    'chaplin',

    'models/base/model',
    'models/base/collection',

    'models/base/sync-collection-model',
    'models/base/sync-collection',

    'lib/utils'
], function(
    _, Chaplin,
    Model, Collection,
    SyncCollectionModel, SyncCollection,
    utils
) {
    'use strict';

    var ClaimModel = Model.extend({
        del: function(fn) {
            var _this = this;
            utils.ajax(utils.getApiUrl('/pages/claim/' + this.get('id')), 'DELETE', {}).complete(function(xhr, status) {
                if (status === 'success') {
                    status  = xhr.responseJSON && xhr.responseJSON.status;
                }

                var deleted = (status === 'success');

                _this.set('deleted', deleted);

                fn( deleted ? null : status);
            });
        }
    });

    var ClaimCollection = SyncCollection.extend({
        model: ClaimModel
    });

    var ClaimsPageModel = SyncCollectionModel.extend({
        urlPath: '/pages/claims',
        defaults: {
        },
        collectionClass: ClaimCollection,
        urlParams: function() {
            var params = SyncCollectionModel.prototype.urlParams.apply(this, arguments);
            params.fromDate = utils.fmtDate(this.get('fromDate'));
            params.toDate = utils.fmtDate(this.get('toDate'));
            return params;
        },
        parse: function(data) {
            var i, li, item, items;

            items = data.items;
            for (i=0,li=items.length;i<li;i++) {
                item = items[i];
            }

            return SyncCollectionModel.prototype.parse.apply(this, arguments);
        }
    });

    return ClaimsPageModel;
});
